import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../../styles/cssinjs/helpers/variables.js";

export default function IndustryTypesCards({ data }) {
  return (
    <div className="container card--default has-three-col mt-5 md:ml-0 md:mr-0">
      {data.map((item, count) => {
        return (
          <a
            key={count}
            href={item.href}
            className="btn-outline bg:hover-white text-brandcolor fw-700 text-md"
          >
            {item.title}
          </a>
        );
      })}
      <style jsx>{`
        .card--default {
          display: flex;
          gap: 40px;
          justify-content: center;
          max-width: 950px;
        }
        .card--default > * {
          width: 176px;
          height: 76px;
          padding: 24px;
          line-height: ${lineHeight[7]};
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .card--default > *:hover {
          box-shadow: 0 3px 6px 0 rgba(48, 58, 71, 0.08),
            0 10px 20px 0 rgba(48, 58, 71, 0.15);
        }
        @media (max-width: ${viewport.tablet.sm}) {
          .card--default {
            gap: 20px;
            width: auto;
            flex-direction: column;
          }
          .card--default > * {
            width: auto;
            padding: 10px 24px;
            font-size: ${font.size.sm[4]};
            height: 48px;
            background: ${colors.primitive.white.default};
            box-shadow: 0 1px 2px 0 rgba(48, 58, 71, 0.2),
              0 1px 3px 0 rgba(48, 58, 71, 0.1);
          }
          .card--default > *:hover {
            box-shadow: none;
          }
        }
      `}</style>
    </div>
  );
}
